import React from 'react';
import { Form, Formik } from 'formik';

import { DefaultFilledButton, PrimaryButton, ResponsiveButtonGroup } from '@magoosh/lib/button';

import { ApplicationCycleFilters, ApplicationCycleFilterConfig } from '@admissions/types';

import CheckboxFilter from './checkbox_filter';
import RadioFilter from './radio_filter';

interface Props {
  filters: ApplicationCycleFilters;
  filtersConfig: ApplicationCycleFilterConfig[];
  onSave: (updatedFilters: ApplicationCycleFilters) => void;
  onClose: () => void;
}

const ModalFilters: React.FC<Props> = (props) => {
  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    props.onSave(values);
    props.onClose();
  };

  return (
    <Formik initialValues={props.filters} onSubmit={onSubmit}>
      {({ values, isSubmitting, setFieldValue }) => (
        <Form>
          {
            props.filtersConfig.map((filterConfig, idx) => (
              <div key={idx} className="u-margin-B-s">
                <h4>{filterConfig.name}</h4>
                <hr className="u-margin-V-xxs" />

                {
                  filterConfig.multiple ? (
                    <CheckboxFilter
                      filterConfig={filterConfig}
                      onChange={(values) => setFieldValue(filterConfig.key, values)}
                      value={values[filterConfig.key]}
                    />
                  ) : (
                    <RadioFilter
                      filterConfig={filterConfig}
                      value={values[filterConfig.key]}
                    />
                  )
                }
              </div>
            ))
          }

          <ResponsiveButtonGroup>
            <PrimaryButton submitting={isSubmitting} type="submit">
              Apply
            </PrimaryButton>

            <DefaultFilledButton onClick={props.onClose}>
              Cancel
            </DefaultFilledButton>
          </ResponsiveButtonGroup>
        </Form>
      )}
    </Formik>
  );
};

export default ModalFilters;
